import { VStack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export const AuthFieldsWrapper = ({ children }: PropsWithChildren<{}>) => {
  return <VStack spacing={3}>{children}</VStack>;
};
